import QuestionViewVerbal from "./QuestionViewVerbal";
import QuestionModel from "../../maths/QuestionModel";

export default class QuestionViewVerbalConversion extends QuestionViewVerbal{
    constructor(question) {
		super(question);
	}

	getHeaderText() {
		const data = P3.assets.json("templates");
		this._answer = this._question.answer;

		let template = this._getTemplate(data);
		let text = template ? template.text : "";
		let words = data.words;

		switch (this.question.type) {
			case QuestionModel.TYPE_MISSING_ANGLE: {text = this._conversionPerecentOfX(text); break;}
			case QuestionModel.TYPE_PERIMETER: {text = this._perimeter(text); break;}
			case QuestionModel.TYPE_COVERSION_X_IN_Y: {text = this._conversionXinY(text); break;}
			case QuestionModel.TYPE_COVERSION_SUBTRACTION: {text = this._conversionSubtraction(text); break;}
			case QuestionModel.TYPE_COVERSION_ADDITION: {text = this._conversionAddition(text); break;}
			case QuestionModel.TYPE_COVERSION_PERCENT_OF_X: {text = this._conversionPerecentOfX(text); break;}
			case QuestionModel.TYPE_COVERSION_MULTIPLICATION: {text = this._conversionMultiplication(text); break;}
		}

		let items = this.generateWords(template.text, words.carry_items_liquid, /\[CARRY_ITEM_LIQUID([0-9])?]/g);
		for (const i in items) {
			if (items.hasOwnProperty(i)) {
				text = text.replace(new RegExp(P3.utils.escape(i), "g"), items[i]);
			}
		}

		items = this.generateWords(template.text, words.items, /\[ITEM([0-9])?]/g);
		for (const i in items) {
			if (items.hasOwnProperty(i)) {
				text = text.replace(new RegExp(P3.utils.escape(i), "g"), items[i]);
			}
		}

		items = this.generateWords(template.text, words.character_class, /\[CHARACTER_CLASS([0-9])?]/g);
		for (const i in items) {
			if (items.hasOwnProperty(i)) {
				text = text.replace(new RegExp(P3.utils.escape(i), "g"), items[i]);
			}
		}

		text = this._replaceLocation(data.words.locations, text);
		text = this._replaceNames(data.words.names, text);
		text = this._replaceEnemies(data.words.enemies, text);
		text = this._replaceWeapons(data.words.defenceitem, text);

		text = this._replaceUnits(text);
        //^ it was getting mixed up between units (saying how many days is 5 minutes etc), swapping for code that works in base verbal view

		text = this._replaceItems(data.words.item_measurement, text);
		text = this._replaceCurrency(data.words.currency, text);

		return text;
	}

	_getTemplate(data){
        const split = this._question.template.split("/");
        let templates = data.templates[split[0]][split[1]];

        if (templates && templates.length > 0) {
			templates = templates.slice().filter(x => this.filterTemplate(x));
        } else return "ERROR: NO TEMPLATE FOUND";

		return P3.utils.selectRandom(templates);
	}

	_replaceUnits(text){
		let unit = text.match(/\[UNIT([0-9])?]/g);

		if(unit)
			switch (this.question.type) {
				default:{
					for (let i = 0; i < unit.length; i++)
						text = text.replace(unit[i], this.question.units[i].long);
					break;
				}
				case QuestionModel.TYPE_MISSING_ANGLE:{
					for (let i = 0; i < unit.length; i++)
						text = text.replace(unit[i], this.question.unit.long);
					break;
				}
				case QuestionModel.TYPE_PERIMETER:{
					for (let i = 0; i < unit.length; i++)
						text = text.replace(unit[i], " " + this.question.units.long);
					break;
				}
				case QuestionModel.TYPE_COVERSION_PERCENT_OF_X:{
					text = text.replace(unit, this.question.units[1].long);
					break;
				}
				case QuestionModel.TYPE_COVERSION_MULTIPLICATION:{
					text = text.replace(unit, this._question.units[this._question.units.length - 1].short);
				}
			}

		return text;
	}

	_replaceLocation(locations, text){
		let match = text.match(/\[LOCATION([0-9])?]/g);
		if (match){
			for (let i = 0; i < match.length; i++) {
				text = text.replace(match[i], P3.utils.selectRandom(locations));
			}
		}
		return text;
	}

	_replaceNames(names, text){
		let match = text.match(/\[NAME([0-9])?]/g);
		if (match){
			if(this.question.type === QuestionModel.TYPE_COVERSION_SUBTRACTION){
				let lastMatch = '';
				let lastName = '';
				let selectedNames = P3.utils.copyObject(names, true);
				for (let i = 0; i < match.length; i++) {
					if(lastMatch !== match[i])
						lastName = P3.utils.selectRandom(selectedNames);
					lastMatch = match[i];
					text = text.replace(lastMatch, lastName);
					selectedNames.splice(selectedNames.indexOf(lastName), 1);
				}
			}else
				text = text.replace(match, P3.utils.selectRandom(names));
		}
		return text;
	}

	_replaceEnemies(enemies, text){
		let match = text.match(/\[ENEMY([0-9])?]/g);
		if (match)
			text = text.replace(match, P3.utils.selectRandom(enemies));
		return text;
	}

	_replaceWeapons(defenceitem, text){
		let match = text.match(/\[DEFENCE([0-9])?]/g);
		if (match){
			text = text.replace(match, P3.utils.selectRandom(defenceitem));
		}
		return text;
	}

	_replaceItems(items, text){
		if(this.question.hasOwnProperty('item')){
			if(this.question.item === null) return text;
			let match = text.match(/\[ITEM_MEASUREMENT([0-9])?]/g);
			if (match)
				text = text.replace(match, P3.utils.selectRandom(items[this.question.item]));
		}
		return text;
	}

	_replaceCurrency(currency, text){
		let match = text.match(/\[CURRENCY([0-9])?]/g);
		let cur = P3.utils.selectRandom(currency);

		if(match)
			for (let i = 0; i < match.length; i++)
				text = text.replace(match[i], cur);

		return text;
	}

	_conversionXinY(text){
		let match = text.match(/\[VALUE([0-9])?]/g);
		if (match)
			text = text.replace(match, this._question.values[this._question.reversed ? 1 : 0].value);
		return text;
	}

	_conversionSubtraction(text){
		let match = text.match(/\[VALUE([0-9])?]/g);

		if(this._question.part === 3){
			text = text.replace(match[0], this.question.values[1].value);
			text = text.replace(match[1], this.question.values[0].value);
		}else{
			text = text.replace(match[0], this.question.values[0].value * this.question.conversion);
			text = text.replace(match[1], this.question.values[3].value);
		}

		return text;
	}

	_conversionAddition(text){
		let match = text.match(/\[VALUE([0-9])?]/g);
		if(match){
			text = text.replace(match[0], this.question.values[1].value);
			text = text.replace(match[1], this.question.values[0].value);
		}
		return text;
	}

	_conversionPerecentOfX(text){
		let match = text.match(/\[VALUE([0-9])?]/g);
		if(match){
			text = text.replace(match[0], this.question.values[0].value);
			text = text.replace(match[1], this.question.values[1].value);
		}
		return text;
	}

	_conversionMultiplication(text){
		let match = text.match(/\[VALUE([0-9])?]/g);
		if(match){
			text = text.replace(match[0], this.question.values[0].value);
			text = text.replace(match[1], this.question.values[1].value);
		}
		return text;
	}

	_perimeter(text){
		const values = this.generateValues(text, /\[VALUE([0-9])?]/g);
		for (const i in values) {
			if (values.hasOwnProperty(i)) {
				text = text.replace(new RegExp(P3.utils.escape(i), "g"), values[i]);
			}
		}
		return text;
	}

	initInputField() {
    	super.initInputField();
		if(!this.question.answer.hasOwnProperty('_unit')) return;
		const unitLabel = new PIXI.Text(this.question.answer.unit, {fontSize: 40, fontFamily: "BBC Reith Sans", fontWeight: "bold"});
		unitLabel.anchor.set(0, 0.5);
		unitLabel.resolution = 2;
		unitLabel.position.set(this._inputField.width * 0.5, 0);
		this._inputField.addChild(unitLabel);
	}

	filterTemplate(x) {
    	switch (this.question.type) {
			case QuestionModel.TYPE_MISSING_ANGLE: return x.hasOwnProperty('part');
			case QuestionModel.TYPE_COVERSION_X_IN_Y: return x.reversed === this.question.reversed;
			case QuestionModel.TYPE_COVERSION_PERCENT_OF_X: return true;
			case QuestionModel.TYPE_COVERSION_MULTIPLICATION: {
				if(x.type.constructor === Array){
					for (let i = 0; i < x.type.length; i++) {
						if(x.type[i] === this.question.unitType || x.type[i] === 'any')
							return true;
					}
					return false
				}else
					return (x.type === this.question.unitType || x.type === 'any');
			}
			case QuestionModel.TYPE_COVERSION_EQUIVALENT: return true;
			case QuestionModel.TYPE_COVERSION_SUBTRACTION: {
				if(x.part !== this.question.part) return false;
				if(x.type.constructor === Array){
					for (let i = 0; i < x.type.length; i++) {
						if(x.type[i] === this.question.unitType || x.type[i] === 'any')
							return true;
					}
					return false
				}else
					return (x.type === this.question.unitType || x.type === 'any');
			}
			default: {
				return x.part === this.question.part;
			}
		}
	}
}